import classNames from "classnames";
import _ from "lodash";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { PlayTable } from "../../../../components";
import { useDefaultPlayData } from "../../../../hooks";
import { useCreatePlayMutation } from "../../../../redux/slices";
import { usePlaybookContext } from "../../playbook-context";
import styles from "./playbook-play-finder.module.scss";

const PlaybookPlayFinder = () => {
  const [creatingPlay, setCreatingPlay] = useState(false);
  const { addingPlay, selectedPlaybook: playbook, addPlaysToPlaybook } = usePlaybookContext();
  const { getDefaultPlayData } = useDefaultPlayData();
  const [createPlay] = useCreatePlayMutation();
  const navigate = useNavigate();

  if (!playbook) return null;

  const handleClickCreatePlay = async () => {
    const playData = getDefaultPlayData();
    try {
      setCreatingPlay(true);
      const newPlayResponse = await createPlay({ play: playData }).unwrap();
      setCreatingPlay(false);
      addPlaysToPlaybook([newPlayResponse.id]);
      navigate(`/plays/${newPlayResponse.id}`, { state: { from: `/home/playbooks/${playbook.id}` } });
    } catch (err) {
      setCreatingPlay(false);
      console.error(err);
    }
  };

  return (
    <div
      className={classNames(styles.playbookPlayFinder, {
        [styles.addingPlay || ""]: addingPlay,
      })}
    >
      <PlayTable
        activePlayId={undefined}
        setActivePlayId={_.noop}
        openPlayTab={_.noop}
        openEditPlayDetails={_.noop}
        creatingPlay={creatingPlay}
        handleClickCreatePlay={handleClickCreatePlay}
        playbooksPage={true}
      />
    </div>
  );
};

export default PlaybookPlayFinder;
